module.exports = __webpack_public_path__ + "static/media/bg3m.50d84f71.jpg";